module.exports = __webpack_public_path__ + "img/1.b53bc822.jpg";